// @flow
import React from "react";
import { type SearchScopeEnum } from "data/types";
import SearchScopeSelect from "./SearchScopeSelect";
import styles from "./MainSearchScope.module.css";
import { getClassNames } from "data/utils";

type Props = {
    /** initial search scope */
    searchScope: SearchScopeEnum,
    /** initial search scope itemUri */
    itemUri: string,
    /** callback when user changes scope
     * @param {SearchScopeEnum} searchScope new search scope
     * @param {string} itemUri new scoped itemUri
     */
    onChange: (searchScope: SearchScopeEnum, itemUri: ?string) => void,
};

/**
 * will render SearchScope selection with subselections
 */
const MainSearchScope = ({
    className,
    searchScope,
    itemUri,
    scopeItemUri,
    onChange,
}: Props) => (
    <SearchScopeSelect
        className={getClassNames(styles.scope, className)}
        radioClassName={styles.radio}
        actionClassName={styles.btn}
        itemUri={itemUri}
        searchScope={searchScope}
        onChange={onChange}
    />
);

export default MainSearchScope;
